import React from 'react'

export interface ResultsState {
  hideTeamPositions: boolean
  noAnimations: boolean
  allowCustomTemplateEdits: boolean
  onCustomTemplateEdit: (val: API.ReportingTemplateLayoutUpdateRequest) => void
}

/**
 * Action
 */
interface UpdateHideTeamPositions {
  type: 'UpdateHideTeamPositions'
  payload: boolean
}

interface UpdateNoAnimations {
  type: 'UpdateNoAnimations'
  payload: boolean
}

interface UpdateAllowCustomTemplateEdits {
  type: 'UpdateAllowCustomTemplateEdits'
  payload: boolean
}

interface UpdateOnCustomTemplateEdit {
  type: 'UpdateOnCustomTemplateEdit'
  payload: (val: API.ReportingTemplateLayoutUpdateRequest) => void
}

export type Actions = UpdateHideTeamPositions | UpdateNoAnimations | UpdateAllowCustomTemplateEdits | UpdateOnCustomTemplateEdit

/**
 * Reducer
 */

export const reducer: React.Reducer<ResultsState, Actions> = (state, action) => {
  switch (action.type) {
    case 'UpdateHideTeamPositions':
      return {
        ...state,
        hideTeamPositions: action.payload
      }
    case 'UpdateNoAnimations':
      return {
        ...state,
        noAnimations: action.payload
      }
    case 'UpdateAllowCustomTemplateEdits':
      return {
        ...state,
        allowCustomTemplateEdits: action.payload
      }
    case 'UpdateOnCustomTemplateEdit':
      return {
        ...state,
        onCustomTemplateEdit: action.payload
      }
    default:
      return state
  }
}
